import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { storage } from '@/configs/storage';
import { NOTIFICATION_STORE_KEY } from '@/features/notifications/constants/store';

export type NotificationStore = {
  token?: string;
  updateToken: (token?: string) => void;
  reset: () => void;
};

export const useNotificationStore = create<NotificationStore>()(
  persist(
    (set) => ({
      token: undefined,
      updateToken: (token?: string) => set({ token: token }),
      reset: () => set({ token: undefined })
    }),
    {
      name: NOTIFICATION_STORE_KEY,
      storage: createJSONStorage(() => storage)
    }
  )
);
